export default __webpack_public_path__ + "static/media/icon-question.ad27d6f7.png";